import React, { Component } from 'react';
import {
    Modal,
    Row,
    Typography,
    Button,
    Spin,
    message,
    Col,
} from 'antd';
import {
    CloseOutlined,
    PrinterOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux';
import ButtonItem from '../../../Components/ButtonItem';
import qz from 'qz-tray';

const { Title, Text } = Typography;


class ModalElegirImpresora extends Component {

    state = {
        loading: false,
        impresoras: [],
        impresoraSeleccionada: null,
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.encontrarImpresora();
        }
    }

    encontrarImpresora = async () => {
        if (!qz.websocket.isActive()) {
            await qz.websocket.connect();
        }

        if (this.props.impresoraSeleccionada) {
            this.setState({ impresoraSeleccionada: this.props.impresoraSeleccionada });
        }

        qz.printers.find().then((data) => {
            this.setState({ impresoras: data, loading: false });
        }).catch((err) => {
            message.error("Error al encontrar impresoras");
            this.setState({ loading: false });
            console.error("Error al encontrar impresoras:", err);
        });
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    handleConfirmarImpresora = () => {
        this.props.onConfirmarImpresora(this.state.impresoraSeleccionada);
    }

    handlePruebaImpresora = async () => {
        try {

            if (!this.state.impresoraSeleccionada) {
                message.error("Por favor, selecciona una impresora antes de imprimir.");
                return;
            }

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect();
            }


            const config = await qz.configs.create(this.state.impresoraSeleccionada ? this.state.impresoraSeleccionada : "", { encoding: 'Cp1252' });

            await qz.print(config, [
                {
                    type: 'raw',
                    format: 'plain',
                    data: 'prueba\n\n\n' // texto + saltos de línea para avanzar papel
                },
            ]);

            await qz.print(config, [
                {
                    type: 'raw',
                    format: 'hex',
                    data: '1B700019FA' // abrir cajón100
                }
            ]);
            await qz.websocket.disconnect();

        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            message.error('Error al imprimir ticket: ' + err.message);
        }
    }

    render() {
        return (
            <Modal
                title={null}
                visible={this.props.visible}
                onCancel={this.handleCancel}
                footer={null}
                width={700}
                centered
                closable={false}
                maskClosable={false}
                style={{ borderRadius: '8px' }}
            >
                <Spin spinning={this.state.loading} tip="Cargando impresoras...">
                    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '300px' }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                            backgroundColor: 'white',
                            padding: '10px 20px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                            <Title level={3} style={{ margin: 0, color: '#1976d2' }}>Selecciona una impresora</Title>
                            <Button
                                type="text"
                                icon={<PrinterOutlined />}
                                onClick={this.handlePruebaImpresora}
                                style={{ fontSize: '16px' }}
                                disabled={this.state.loading || !this.state.impresoraSeleccionada}
                            >Prueba</Button>
                            <Button
                                type="text"
                                icon={<CloseOutlined />}
                                onClick={this.handleCancel}
                                style={{ fontSize: '16px' }}
                                disabled={this.state.loading}
                            />
                        </div>

                        {/* Impresoras */}
                        <Row gutter={[16, 16]} justify="center">
                            {this.state.impresoras && Array.isArray(this.state.impresoras)
                                ? this.state.impresoras.map((impresora, index) => (
                                    <Col key={index} span={8}>
                                        <div
                                            onClick={() => this.setState({ impresoraSeleccionada: impresora })}
                                            style={{
                                                width: '100%',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                backgroundColor: 'white',
                                                padding: '30px 20px',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                                transition: '0.3s',
                                                border:
                                                    this.state.impresoraSeleccionada === impresora
                                                        ? `3px solid #4caf50`
                                                        : '2px solid #e0e0e0',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: '#e0f7fa',
                                                    padding: '20px',
                                                    borderRadius: '50%',
                                                    marginBottom: '15px',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                <PrinterOutlined style={{ fontSize: '32px', color: '#1976d2' }} />
                                            </div>
                                            <Text
                                                strong
                                                style={{
                                                    display: 'block',
                                                    fontSize: '10px',
                                                    color: '#333',
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {impresora}
                                            </Text>
                                        </div>
                                    </Col>
                                ))
                                : null}
                        </Row>

                        {/* Confirmar selección */}
                        <div style={{ marginTop: '30px' }}>
                            <ButtonItem
                                type="primary"
                                size="large"
                                disabled={!this.state.impresoraSeleccionada || this.state.loading}
                                loading={this.state.loading}
                                onClick={this.handleConfirmarImpresora}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    backgroundColor: '#00b5e2',
                                    borderColor: '#00b5e2',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}
                            >
                                {this.state.loading ? 'Procesando...' : `Seleccionar ${this.state.impresoraSeleccionada || ''}`}
                            </ButtonItem>
                        </div>
                    </div>
                </Spin>
            </Modal>
        )
    }
}


const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalElegirImpresora);